"use strict";

exports.objectTypeHash = {
  onkn: 'onkn',
  rh: 'rh',
  fh: 'fh',
  tchaikovsky: 'tchaikovsky'
};
exports.objectTypeTitlesHash = {
  onkn: 'Нематериальное культурное наследие',
  rh: 'Религиозное наследие',
  fh: 'Зарубежное наследие',
  tchaikovsky: 'Чайковский'
};
exports.objectRubricToTitlesHash = {
  'traditions/religion-heritage': 'Религиозное наследие',
  'traditions/culture-heritage': 'Нематериальное культурное наследие',
  'traditions/foreign-heritage': 'Зарубежное наследие'
};
exports.objectTypeTitlesHash = {
  onkn: 'Нематериальное культурное наследие',
  rh: 'Религиозное наследие',
  fh: 'Зарубежное наследие',
  tchaikovsky: 'Чайковский'
};
exports.objectTypeGenderHash = {
  onkn: 'neuter',
  rh: 'neuter',
  fh: 'neuter',
  tchaikovsky: 'male'
};